import { render, staticRenderFns } from "./Permissao.vue?vue&type=template&id=494cf78b&"
import script from "./Permissao.vue?vue&type=script&lang=js&"
export * from "./Permissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports